"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "event-chart"
  }, [_c("p", {
    staticStyle: {
      display: "inline-block"
    }
  }, [_vm._v(" Inquiries ")]), _c("router-link", {
    staticStyle: {
      float: "right"
    },
    attrs: {
      to: `/leads/list`
    }
  }, [_c("el-button", {
    staticStyle: {
      margin: "2px"
    },
    attrs: {
      type: "text",
      size: "small"
    }
  }, [_vm._v(" View All "), _c("i", {
    staticClass: "el-icon-arrow-right"
  })])], 1), _c("div", {
    staticStyle: {
      "margin-bottom": "15px"
    }
  }), _c("el-table", {
    attrs: {
      data: _vm.list,
      border: "",
      "max-height": "360"
    }
  }, [_c("el-table-column", {
    attrs: {
      width: "60",
      align: "left",
      label: "ID"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("router-link", {
          attrs: {
            to: "/follow-ups/list/" + scope.row.id
          }
        }, [_c("el-link", {
          attrs: {
            type: "danger"
          }
        }, [_vm._v(" #" + _vm._s(scope.row.id) + " ")])], 1)];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "Client",
      width: "140",
      align: "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("i", {
          staticClass: "el-icon-office-building"
        }), _vm._v(" " + _vm._s(scope.row.client.name) + " "), _c("br"), _c("i", {
          staticClass: "el-icon-user"
        }), _vm._v(" " + _vm._s(scope.row.clientsContact.firstName + " " + (scope.row.clientsContact.lastName || "")) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "Responsible",
      width: "120",
      align: "left"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(scope.row.salesManager.fullName) + " "), _c("br"), _vm._v(" " + _vm._s(scope.row.salesCoordinator.fullName) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "Last Follow Up"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("div", {
          staticClass: "text-bold"
        }, [_vm._v(" " + _vm._s(_vm.agendaLabels[scope.row.followUp.agenda] || scope.row.followUp.agenda) + " ")]), _c("br"), _vm._v(" -" + _vm._s(scope.row.followUp.assignedUser.fullName) + " "), _c("br"), _c("small", [_vm._v("Due: " + _vm._s(_vm._f("moment")(scope.row.followUp.dueDate, "DD MMMM YYYY")))])];
      }
    }])
  })], 1)], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;